
$(".mobile_main_slider").flickity({
    cellAlign: "left",
    groupCells: true,
    pageDots: false,
    wrapAround: false,
    contain: true,
    prevNextButtons: true,
});
$(".header--touch .ariaToggle[aria-controls='main-menu-mobile']").click(function () {
    $("body").toggleClass("active_menu");
});
$(".header--touch.medium-up--hide .ariaToggle[aria-controls='main-menu-mobile']").click(function () {
    // $('body').toggleClass('active_menu');
    $(".touch__nav").toggleClass("expanded");
});
$(".header--touch.medium-up--hide a.nav-carat.ariaToggle").click(function () {
    $(".header--touch.medium-up--hide ul.touch__nav__links .main-menu-dropdown").toggleClass("expanded");
});

if (window.location.href.includes('apps/retextion')) {
    const swapButtons = () => {
      const getItNow = document.querySelector('button.get-it-now-button');
      const giftNextOrder = document.querySelector('button.btn-gift-next-order');
  
      if (!getItNow || !giftNextOrder) {
        setTimeout(swapButtons, 100);
        return;
      }
  
      const parent1 = getItNow.parentNode;
      const parent2 = giftNextOrder.parentNode;  
  
      parent1.appendChild(giftNextOrder);
      parent2.appendChild(getItNow);
    };
  
    swapButtons();
  }

$( document ).ready(function() {
  /*** PDP swatches js ***/
   $('.swatch-inner input').on('change',function(){
   $(this).parents('.selector-wrapper').find('select option').removeAttr('selected');
     $(this).parents('.selector-wrapper').find(`select option[value="${$(this).val()}"]`).attr("selected","selected");
   $(this).parents('.selector-wrapper').find('select').trigger('change');
});
  if($('.rtx-subscription-label.is-selected[for="purchaseTypeSubscription"]').length > 0){
var pricesub= $('.rtx-subscription-label  span[data-rtx-subscription-price]').text();
          //alert(pricesub);
          if(pricesub.indexOf('%') >-1){
           pricesub=pricesub.split('%')[1];
              
          }
    $('.product__price span[data-product-price]').text(pricesub);
    
}
    /*** PDP swatches js END HERE ***/
$('.readmore').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'block';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'none';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'block';
if ($(window).width() < 750) {
  window.scrollTo({top: 900, behavior: 'smooth'});
} else {
  window.scrollTo({top: 500, behavior: 'smooth'});
}
})

$('.readmore').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product_description_outer_mobile .product-description-full');
descriptionFull.style.display = 'block';
var descriptionShort = document.querySelector('.product_description_outer_mobile .product-description-short');
descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product_description_outer_mobile .product-description-full');
descriptionFull.style.display = 'none';
var descriptionShort = document.querySelector('.product_description_outer_mobile .product-description-short');
descriptionShort.style.display = 'block';
if ($(window).width() < 750) {
  window.scrollTo({top: 900, behavior: 'smooth'});
} else {
  window.scrollTo({top: 500, behavior: 'smooth'});
}
})
  

// $(".blog-post-metafield").flickity({
//     cellAlign: "left",
//     groupCells: true,
//     pageDots: false,
//     wrapAround: false,
//     contain: true,
//     prevNextButtons: true,
// });

$('.blog-post-metafield').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0222/9882/0682/files/img_231176.png?v=1687429067"></div>',
  nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0222/9882/0682/files/img_231176.png?v=1687429067"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    }
  ]
});

  
});

jQuery.getJSON("/cart.js", function (cart){
  
    var total_price = cart.total_price / 100;
    var remainingPrice = 99-total_price;
    remainingPrice = remainingPrice.toFixed(2);
    if (total_price < 99) {
        $('.checkout__button').attr('disabled','');
        $('.cart-page-remaining-price').text(`$${remainingPrice}`);
        $('.min-price-limit').show();
    } else {
        $('.checkout__button').removeAttr('disabled');
        $('.min-price-limit').hide();
    }
  
 });


$(document).ready(function(){
  $('.product__thumbs .slick-dots').slick({
    infinite: false,
    vertical: false,
    verticalSwiping: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<div class="prd_thumb_slide_prev slick-prev"><img src="https://cdn.shopify.com/s/files/1/0222/9882/0682/files/img_231176.png?v=1687429067"></div>',
    nextArrow: '<div class="prd_thumb_slide_next slick-next"><img src="https://cdn.shopify.com/s/files/1/0222/9882/0682/files/img_231176.png?v=1687429067"></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ],
    onInit: function() {
      // Add margin directly through slick initialization callback
      $('.product__thumbs .slick-slide').css('margin', '8px');
    }
  });




$('.prd_thumb_slide_prev').removeClass('slick-disabled');
$('.prd_thumb_slide_next').removeClass('slick-disabled');

// $('.slick-arrow').click(function(){
//     $('.prd_thumb_slide_prev').removeClass('slick-disabled');
//     $('.prd_thumb_slide_next').removeClass('slick-disabled');
// });
$('.slick-arrow').click(function(){
    var currentIndex = $(".slick-track").find('.slick-active').index();
    $(".slick-track").find('li.slick-slide').removeClass('slick-active');
    $(".slick-track").find('li.slick-slide').eq(currentIndex).addClass('slick-active');
   $('.prd_thumb_slide_prev').removeClass('slick-disabled');
   $('.prd_thumb_slide_next').removeClass('slick-disabled');
   
});



  
});

$(document).ready(function() {
  $(".set > span").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > span i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > span i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > span").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });
});
$(document).on('keyup','#CartSpecialInstructions' , function(){
  var label = $(this).prev('label');
  if(this.value !== '') {
        label.addClass('label--float ');
      } else {
        label.removeClass('label--float ');
      }
})
if(window.location.href.indexOf('/blogs/seafood-recipes') > -1){
$(".pd-video-play-icon").click(function(){
    $('.rk_image').css("display","none");
    $('.cstm-image-content').css("display", "none");
   var video_src= $(this).parents('.cstm-image-video-main').find('iframe').attr('src')+'"&autoplay=1"';
    // $(this).parents('.cstm-image-video-main').find('iframe').attr('src',video_src);
    $('.rk_print_hide').css("display","block");
});

 var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let player;
var video_id= $('#youtube_rk_video').attr('data-src');

// Load the YouTube player once the API is ready
function onYouTubeIframeAPIReady() {
    player = new YT.Player('youtube_rk_video', {
        height: '100%',
        width: '100%',
        videoId:video_id, // Replace with your video ID
        events: {
            onReady: onPlayerReady
        }
    });
}

// Triggered when the player is ready
function onPlayerReady(event) {
    const playButton = document.getElementById('pd-video-play-icon');
    playButton.addEventListener('click', () => {
        player.playVideo(); // Play the video
        player.unMute(); // Ensure the video is unmuted
    });
}

}
// $(window).load(function() {
   $('.slick-slide').removeClass('slick-active');
if ($('.slick-slide').length > 0) {
    $('.slick-slide').eq(0).addClass('slick-active');  // Keeps the first slide active initially
  }
   $('.slick-slide').click(function() {
  $('.slick-slide').removeClass('slick-active');
  $(this).addClass('slick-active');
  });
 // });


// $(document).ready(function() {
//   if ($('.slick-slide').length > 0) {
//     $('.slick-slide').eq(0).addClass('slick-active');  
//   }

//   $('.slick-slide').click(function() {
//    if ($(this).index() !== 0) {
//     $('.slick-slide').removeClass('slick-active');
//     $(this).addClass('slick-active');
//     }
//   });
// });


$( document ).ready(function() {
  var mainHeightProduct = $('.cstm-jtpl-pdp').height()+20;
$('.cstm-data-outer').css('margin-top', mainHeightProduct);
});




// $(document).ready(function() {
//     setTimeout(function() {
//         var maxHeight = 0;
//         $('.grid__item.review__item .review__content.rte').each(function() {
//             var currentHeight = $(this).outerHeight();
//             if (currentHeight > maxHeight) {
//                 maxHeight = currentHeight;
//             }
//         });
//         $('.grid__item.review__item .review__content.rte').css('height', maxHeight + 50);
//     }, 200);
// });


// $(document).ready(function() {
// alert(1);
//     function adjustMaxHeight() {
//         var maxHeight = 0;
//         $('.grid__item.review__item .review__content.rte').each(function() {
//             var currentHeight = $(this).outerHeight();
//             if (currentHeight > maxHeight) {
//                 maxHeight = currentHeight;
//             }
//         });
//         $('.grid__item.review__item .review__content.rte').css('height', maxHeight + 50);
//     }
//     adjustMaxHeight();


//     $(window).load(function() {
//         adjustMaxHeight();
//     });
// });








